import { cn } from '@/styles/utils';
import React from 'react';

type StorageType = '냉장' | '냉동' | string;

interface StorageTagProps {
  type: StorageType;
  className?: string;
}

const StorageTag: React.FC<StorageTagProps> = ({ type, className }) => {
  const getTagColors = (storageType: StorageType) => {
    switch (storageType) {
      case '냉장':
        return 'text-[#549967] border-[#549967]';
      case '냉동':
        return 'text-[#4D70D9] border-[#4D70D9]';
      default:
        return 'text-[#794DD9] border-[#794DD9]';
    }
  };

  return (
    <span
      className={cn(
        'w-10 h-5 px-2 py-0 rounded-sm bg-transparent border',
        getTagColors(type),
        className,
      )}
    >
      {type}
    </span>
  );
};

export default StorageTag;
